// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/cosmos.scss
// module id = 13
// module chunks = 0